import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import { connect, RootStateOrAny, useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { useAuth } from "../../../../utils/hooks/useAuth";
import AddEmail from "../components/AddEmail";
import AddTeam from "../components/AddTeam";
import { FormattedMessage } from "react-intl";
import {useFlags} from "../../../../config/featureFlags";
import TeamsService from "../../Teams/services/teamsService";

function OnBoarding(props) {
  const { user } = useSelector((state: RootStateOrAny) => state.auth);
  const { DISPLAY_CODE_CONTENT } = useFlags();
  const [tabKey, setTabKey] = useState("email");
  const { isAuthorized, hasTeam } = useAuth();

  useEffect(async () => {
    /** A Team is registered synchronisely in
     CODE in background,
     while in LIKUMI there is another page to register the team
     **/
    if (DISPLAY_CODE_CONTENT) {
      await TeamsService.addTeamState({
        name: user?.email,
        registrarUserId: user?.id,
        interests: [],
        emails: [],
      }).then(({ data: { id } }) => {
        localStorage.setItem("teamId", id);
        window.location.href = "/"
      });
    }
  }, []);

  if (!isAuthorized) {
    return <Redirect to="/auth/login" />;
  }
  if (hasTeam) {
    return <Redirect to="/bills" />;
  }

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"></div>

            <div className="d-flex flex-column-fluid flex-center mt-10 mt-lg-0">
              <div
                className="login-signin"
                style={{ display: "block", width: "500px" }}
              >
                <div className="text-center mb-10 mb-lg-20">
                  <h3 className="font-size-h1">
                    {
                      (DISPLAY_CODE_CONTENT) ?
                        <FormattedMessage id="CODE.AUTH.REGISTER.WELCOME" /> :
                        <FormattedMessage id="AUTH.REGISTER.WELCOME" />
                    }
                  </h3>
                </div>

                <Tabs
                  id="controlled-tab-example"
                  activeKey={tabKey}
                  onSelect={(k) => setTabKey(k)}
                  className="m-0"
                >
                  <Tab
                    eventKey="email"
                    title={
                      <div className="badge-wrapper">
                        <span
                          className={`badge mr-2 badge-${
                            tabKey !== "createTeam" ? "primary" : "secondary"
                          }`}
                        >
                          1
                        </span>
                        <FormattedMessage id="AUTH.ONBOARDING.TAB_1" />
                      </div>
                    }
                  >
                    <div
                      className="border-bottom border-right border-left d-flex flex-column-fluid flex-center w-100"
                      style={{ minHeight: "200px" }}
                    >
                      <AddEmail intl={props.intl} setTabKey={setTabKey} />
                    </div>
                  </Tab>
                  <Tab
                    eventKey="createTeam"
                    title={
                      <div className="badge-wrapper">
                        <span
                          className={`badge mr-2 badge-${
                            tabKey === "createTeam" ? "primary" : "secondary"
                          }`}
                        >
                          2
                        </span>
                        <FormattedMessage id="AUTH.ONBOARDING.TAB_2" />
                      </div>
                    }
                  >
                    <div
                      className="border-bottom border-right border-left d-flex flex-column-fluid flex-center"
                      style={{ minHeight: "200px" }}
                    >
                      <AddTeam intl={props.intl} />
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(OnBoarding));
